import moment from "moment/moment";
import {DateFormats} from "@/scripts/Common/DateFormats";

const formatDate = (date: string | undefined, format: string) => {
  if (!date || date.length <= 0) return '';

  return moment(date).format(format);
}

const getCurrentDate = () => moment();

/**
 * Get today's date as a string in the format YYYY-MM-DD
 * @returns string in the format YYYY-MM-DD
 */
const getDateTodayAsString = () => moment().format('YYYY-MM-DD');

const getMinDateRestriction = moment().add(1, 'days').format(DateFormats.ISO8601_LONG);

/**
 * Parses a date string into a Moment object.
 * @param dateString - The date string to parse.
 * @param format - The format to try when parsing the date.
 * @returns The parsed Moment object or null if parsing failed.
 */
const parseDate = (dateString: string | null, format: string): moment.Moment | null => {
  if (!dateString) return null;

  const parsed = moment(dateString, format, true);
  if (parsed.isValid()) {
    return parsed;
  }

  return null;
};

/**
 * Adds days to the given date string and returns it in the same format.
 * @param dateString - The date string in ISO8601 format (YYYY-MM-DD)
 * @param format - The format of the input date string (defaults to ISO8601_LONG)
 * @returns The date string with the specified number of days added, or null if input is null or could not be parsed.
 */
const addDays = (dateString: string | null, days: number, format: string = DateFormats.ISO8601_LONG): string | null => {
  if (!dateString) return null;

  const dateMoment = parseDate(dateString, format);
  if (!dateMoment) {
    console.error(`Invalid date format: ${dateString}`);
    return null;
  }

  return dateMoment.add(days, 'day').format(format);
};

export {
  formatDate,
  getCurrentDate,
  getDateTodayAsString,
  getMinDateRestriction,
  parseDate,
  addDays,
}
